import { render, staticRenderFns } from "./JobNameColumn.vue?vue&type=template&id=4f8eb1eb&"
import script from "./JobNameColumn.vue?vue&type=script&lang=js&"
export * from "./JobNameColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports